import { shape, object } from 'prop-types';
import locationShape from 'shapes/locationShape';
import ssrDataShape from 'shapes/ssrDataShape';

export default shape({
    data: ssrDataShape,
    location: locationShape,
    resultState: object,
});
